module.exports = __webpack_public_path__ + "dist/images/e78a249f07b547f8ef189df14dc40167.svg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/select-role/student.svg
// module id = 475
// module chunks = 0